import { render, staticRenderFns } from "./DNFooter.vue?vue&type=template&id=5462d941"
import script from "./DNFooter.vue?vue&type=script&lang=js"
export * from "./DNFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports